import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Divider, Descriptions, Input, Select, Flex } from 'antd';
import { BaseContainer } from 'components/containers';
import { Editor, ConfirmButton, ListButton } from 'components/elements';
import { getCustomerCenterFaqDetailAPI, putCustomerCenterFaqAPI } from 'api/customer-center';
import { objToLowerCase } from 'utils/utils';
import { customerCenterFaqTypeOptions } from 'data/options';
import { getLocalStorage } from 'hooks/useLocalStorage';
import { URL_ADMIN } from 'routes/AdminRoute';
import { URL_CUSTOMER_CENTER_FAQ, URL_CUSTOMER_CENTER_PRODUCT_FAQ } from 'routes/CommonRoute';

export default function CustomerCenterFaqEdit() {
  const navigate = useNavigate();
  const { no } = useParams();
  const { state } = useLocation();
  const [value, setValue] = useState({});
  const [product_fg, setProductFg] = useState(null);

  const fnGetDetail = async () => {
    await getCustomerCenterFaqDetailAPI(no)
      .then((res) => {
        const { data_info } = res?.data;
        setValue({
          ...objToLowerCase(data_info)
        });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const fnUpd = async () => {
    const { user_name } = getLocalStorage('persist:user');
    const data = {
      ...value,
      writer: user_name,
      product_fg
    };
    await putCustomerCenterFaqAPI(data)
      .then((res) => {
        alert('수정되었습니다.');
        const url = product_fg === 1 ? `${URL_ADMIN}${URL_CUSTOMER_CENTER_PRODUCT_FAQ}` : `${URL_ADMIN}${URL_CUSTOMER_CENTER_FAQ}`;
        navigate(url);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const fnHandleAdd = useCallback((v) => {
    setValue((value) => ({
      ...value,
      ...v
    }));
  }, []);

  useEffect(() => {
    if (no && state?.productFg) setProductFg(Number(state?.productFg));
  }, [no, state]);

  useEffect(() => {
    if (no && (product_fg === 0 || 1)) fnGetDetail();
  }, [no, product_fg]);

  const items = [
    { key: '1', label: '카테고리', children: <Select value={value?.faq_type} style={{ width: '20rem' }} options={customerCenterFaqTypeOptions?.slice(1)} onSelect={(v) => fnHandleAdd({ faq_type: v })} /> },
    { key: '2', label: '제목', children: <Input value={value?.title} onChange={(e) => fnHandleAdd({ title: e.target.value })} /> },
    { key: '3', label: '내용', children: <Editor height="340px" data={value?.content} onChange={(e) => fnHandleAdd({ content: e })} /> }
  ];

  return (
    <>
      <BaseContainer>
        <Descriptions bordered column={1} labelStyle={{ width: '16rem' }} contentStyle={{ textAlign: 'left' }} items={items} />
        <Divider className="divider" />

        <Flex justify={'end'} gap={3}>
          <ConfirmButton label={'작성완료'} onClick={fnUpd} />
          <ListButton
            onClick={() => {
              const url = product_fg === 1 ? `${URL_ADMIN}${URL_CUSTOMER_CENTER_PRODUCT_FAQ}` : `${URL_ADMIN}${URL_CUSTOMER_CENTER_FAQ}`;
              navigate(url);
            }}
          />
        </Flex>
      </BaseContainer>
    </>
  );
}
